import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Typography } from '@latitude/typography';
import {
  StyledItem,
  StyledItems,
  StyledItemImage,
  StyledAdditionalCards,
  Wrapper
} from './AdditionalCardsRebrand.styled';

const COMPONENT_ID = 'additional-cards-rebrand';

const AdditionalCardsBranded = ({ items, heading, trackingId }) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;
  return (
    <Wrapper className={componentIdentifier}>
      <StyledAdditionalCards>
        <Typography.H4>{heading}</Typography.H4>
        <StyledItems className={`${componentIdentifier}-items-container`}>
          {items.map((item, i) => (
            <StyledItem
              noStyle
              key={i}
              href={item.href}
              data-trackid={item.trackId}
              trackProductId={item.productid}
              trackEventData={{
                label: item.title.replace(/(°|<([^]+)>)/gi, ''),
                location: heading
              }}
              className={`${componentIdentifier}-item-container`}
            >
              <StyledItemImage
                src={item.imageSrc.default}
                className={`${componentIdentifier}-item-image`}
              />
              <Typography.LinkRegular>
                {ReactHtmlParser(item.title)}
              </Typography.LinkRegular>
            </StyledItem>
          ))}
        </StyledItems>
      </StyledAdditionalCards>
    </Wrapper>
  );
};

export default AdditionalCardsBranded;
